import { ProductSubCategoryUpdatePage } from "@/features/product-sub-category/pages/ProductSubCategoryUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-sub-category/$id/update")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_sub_category.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductSubCategoryUpdatePage,
});
